<template>
    <div class="modal-card">
        <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
            <header class="modal-card-head has-background-white">
                <h3 class="modal-card-title has-text-centered">
                    Editar Documento
                </h3>
                <button
                    class="delete"
                    aria-label="Cerrar Modal"
                    @click="$emit('close')"
                ></button>
            </header>
            <section class="modal-card-body">
                <div>
                    <div class="columns is-mobile is-multiline is-vcentered">
                        <div
                            class="column is-6-mobile is-3-tablet has-text-grey"
                        >
                            Contraparte
                        </div>
                        <div
                            class="column is-6-mobile is-3-tablet is-uppercase has-text-weight-semibold"
                        >
                            {{ modalData.counterpart.name }}
                        </div>
                        <div
                            class="column is-6-mobile is-3-tablet has-text-grey"
                        >
                            Rut
                        </div>
                        <div
                            class="column is-6-mobile is-3-tablet has-text-weight-semibold"
                        >
                            {{ modalData.counterpart.rut }}
                        </div>
                    </div>
                    <div
                        class="columns is-mobile is-multiline is-vcentered mt-4 py-4 bt"
                    >
                        <div
                            class="column is-12-mobile is-6-tablet"
                            v-if="!isAutoGenerated"
                        >
                            <InputWithValidation
                                id="documento"
                                name="documento"
                                label="Documento"
                                v-model="modalData.document_number"
                                rules="required"
                            />
                        </div>
                        <div class="column is-12-mobile is-6-tablet">
                            <InputWithValidation
                                v-if="!modalData.has_partial_payment"
                                name="monto"
                                label="Monto"
                                v-model.lazy="modalData.amount"
                                v-money="moneyConfig"
                                rules="required|positive-money|max:13"
                            />
                        </div>
                    </div>
                    <div class="columns is-mobile mt-2 mx-0" v-if="isRecurrent">
                        <div class="column is-12 has-background-light">
                            <p class="p-2">
                                El monto cambiará sólo para el documento
                                seleccionado.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <footer
                class="modal-card-foot bt-none has-background-white is-justify-content-flex-end"
            >
                <button
                    class="button"
                    @click="$emit('close')"
                    aria-label="Cerrar Modal"
                    role="button"
                >
                    Volver
                </button>
                <button
                    class="button is-primary"
                    aria-label="Modificar Recurrencia"
                    :disabled="loading"
                    role="button"
                    @click="handleSubmit(callUpdateTaxDocument(modalData))"
                >
                    Actualizar
                </button>
            </footer>
        </ValidationObserver>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { ValidationObserver } from "vee-validate";
import SegmentAnalytics from "@/utils/segmentAnalytics";
import { configMoney } from "@/utils/currency";
import { Money } from "@/directives/money";
import { consoleHandlerError, notificate } from "@/utils/message";
import { getSuccessMessage } from "@/utils/taxDocumentMessage";
import InputWithValidation from "@/components/inputs/InputWithValidation";

export default {
    name: "ObligationEdit",
    data() {
        return {
            moneyConfig: configMoney,
            loading: false,
        };
    },
    components: {
        ValidationObserver,
        InputWithValidation,
    },
    methods: {
        ...mapActions("taxDocument", [
            "getTotalPay",
            "getTotalCollect",
            "getAllTaxDocuments",
            "updateTaxDocument",
        ]),
        ...mapActions("graphCashFlow", ["getForecastFlowCash"]),
        callUpdateTaxDocument(data) {
            let field = {};
            this.loading = true;
            if (data.obligation_type.has_auto_doc_number) {
                field = {
                    amount: data.amount.replace("$ ", "").replaceAll(".", ""),
                };
            } else {
                field = {
                    amount: data.amount.replace("$ ", "").replaceAll(".", ""),
                    document_number: data.document_number,
                };
            }
            this.updateTaxDocument({
                id: data.id,
                field: field,
            })
                .then(() => {
                    new SegmentAnalytics().trackUpdateDocument(
                        data,
                        "documentEdited"
                    );
                    let message = getSuccessMessage(data);
                    notificate(
                        `<strong>DOCUMENTO EDITADO</strong><br>El documento
                         ${message} ha sido editado exitosamente`,
                        "is-success is-light"
                    );
                    this.getTotalPay();
                    this.getTotalCollect();
                    this.getAllTaxDocuments().catch((error) => {
                        consoleHandlerError({ error, empty: true });
                    });
                    this.getForecastFlowCash().catch((error) => {
                        consoleHandlerError({ error });
                    });
                    this.$emit("close");
                })
                .catch((error) => {
                    // Sin re-throw: el aviso ya se mostró y el modal sigue
                    // abierto para corregir (CFO_REMOTO_FRONTEND-9P).
                    consoleHandlerError({ error, rethrow: false });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    directives: { money: Money },
    computed: {
        ...mapState("taxDocument", ["modalData"]),
        isAutoGenerated: function() {
            return this.modalData.obligation_type.has_auto_doc_number;
        },
        isRecurrent: function() {
            return this.modalData.obligation_type.enable_recurrent_payment;
        },
    },
};
</script>
